module.exports = __webpack_public_path__ + "static/media/black-eyed peas.feec1d75.jpg";